<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4><ion-icon name="calendar-outline"></ion-icon> Event List</h4>
        <div class="ml-auto">
          <button
            mat-raised-button
            color="primary"
            (click)="eventAddBtn('Add')"
          >
            Add Event
          </button>
        </div>
      </div>
      <section class="statusbutton">
        <div>
          <button
            mat-raised-button
            class="mr-2 all"
            (click)="ststusBtn(3, 'all')"
          >
            ALL
          </button>
          <button
            mat-raised-button
            class="mr-2 pending"
            (click)="ststusBtn(0, 'pending')"
          >
            Pending
          </button>
          <button
            mat-raised-button
            class="mr-2 approved"
            (click)="ststusBtn(1, 'approved')"
          >
            Approved
          </button>
          <button
            mat-raised-button
            class="mr-2 rejected"
            (click)="ststusBtn(2, 'rejected')"
          >
            Rejected
          </button>
        </div>
      </section>
    </div>
    <div *ngIf="noData == false">
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource" [class.isMobile]="isMobile">
          <ng-container matColumnDef="index">
            <mat-header-cell *matHeaderCellDef class="table-no">
              No.
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index" class="table-no">
              <span class="mobile-label">No :</span>
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="eventName">
            <mat-header-cell *matHeaderCellDef> Event Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Event Name:</span>
              {{ element.eventName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="eventFromDate">
            <mat-header-cell *matHeaderCellDef>
              Event From Date</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Event From Date:</span>
              {{ element.eventFromDate }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="eventFromTime">
            <mat-header-cell *matHeaderCellDef
              >Events From Time</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Events From Time:</span>
              {{ element.eventFromTime }}
            </mat-cell>
          </ng-container>
          <ng-container
            matColumnDef="incubatorName"
            [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
          >
            <mat-header-cell *matHeaderCellDef>Incubator Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Incubator Name:</span>
              {{ element.incubatorName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="remarks">
            <mat-header-cell
              *matHeaderCellDef
              [ngClass]="{ 'd-none': valueGet != '2' && valueGet != 3 }"
              >Remarks</mat-header-cell
            >
            <mat-cell
              *matCellDef="let element"
              [ngClass]="{ 'd-none': valueGet != '2' && valueGet != 3 }"
            >
              <span class="mobile-label">Remarks:</span>
              <span class="eye-icon" *ngIf="element.remarks">
                <ion-icon
                  class="ml-3"
                  name="eye-outline"
                  (click)="viewDescrptionBtn(element.remarks, 'View Remark')"
                ></ion-icon
              ></span>
              <span *ngIf="!element.remarks" class="ml-3"> - </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Status:</span>
              <span *ngIf="element.status == 0" class="Pending"
                >Pending for Approval</span
              >
              <span *ngIf="element.status == 1" class="Approved">Approved</span>
              <span *ngIf="element.status == 2" class="Rejected">Rejected</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Action:</span>
              <span class="ml-lg-2"
                ><img
                  class="newview-doc"
                  (click)="incubateeEvent(element.id)"
                  roleValue="Incubator"
                  [ngClass]="{ 'd-none': roleValue == 'Admin' }"
                  src="assets/images/viewdocument.png"
                  alt=""
              /></span>
              <mat-icon
                class="edit-i"
                (click)="editEvent('Update', element.id)"
                [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
              >
                edit</mat-icon
              >
              <mat-icon
                class="delete-i"
                (click)="deleteEvent(element.id)"
                [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
              >
                delete</mat-icon
              >
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator
        [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 75, 100]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>No Records Found</h6>
    </div>
  </div>
</section>
